import { render, staticRenderFns } from "./WorkflowRun.vue?vue&type=template&id=023a3930"
import script from "./WorkflowRun.vue?vue&type=script&lang=js"
export * from "./WorkflowRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports